import { render, staticRenderFns } from "./Topbar.vue?vue&type=template&id=2b31057a&scoped=true"
import script from "./Topbar.vue?vue&type=script&lang=js"
export * from "./Topbar.vue?vue&type=script&lang=js"
import style0 from "./Topbar.vue?vue&type=style&index=0&id=2b31057a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./Topbar.vue?vue&type=style&index=1&id=2b31057a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b31057a",
  null
  
)

export default component.exports